import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Language {
  code: string;
  label: string;
  nativeLabel: string;
}

@Injectable({ providedIn: 'root' })
export class LanguageService {
  readonly languages: Language[] = [
    { code: 'en', label: 'English', nativeLabel: 'EN' },
    { code: 'hi', label: 'हिंदी',    nativeLabel: 'हि' },
    { code: 'pa', label: 'ਪੰਜਾਬੀ',   nativeLabel: 'ਪੰ' },
    { code: 'gu', label: 'ગુજરાતી', nativeLabel: 'ગુ' },
    { code: 'mr', label: 'मराठी',   nativeLabel: 'म' },
  ];

  constructor(private translate: TranslateService) {}

  /**
   * Initialize translation service.
   * Priority: localStorage saved choice > backend config value > English fallback
   */
  init(configLang?: string): void {
    this.translate.addLangs(this.languages.map(l => l.code));
    this.translate.setDefaultLang('en');
    const saved   = localStorage.getItem('crm-language');
    const lang    = saved || configLang || 'en';
    this.use(lang);
  }

  /** Switch to a language and persist the choice in localStorage */
  use(langCode: string): void {
    const valid = this.languages.find(l => l.code === langCode);
    const code  = valid ? langCode : 'en';
    this.translate.use(code);
    localStorage.setItem('crm-language', code);
  }

  get current(): string {
    return this.translate.currentLang || localStorage.getItem('crm-language') || 'en';
  }

  get currentLanguage(): Language {
    return this.languages.find(l => l.code === this.current) || this.languages[0];
  }
}
